export default __webpack_public_path__ + "static/logo-no-text-633f9951a41d341e2633ed2636d42039.png";